import classNames from "classnames/bind";
import Image from "common/blocks/Image";
import SmartLink from "common/wrapper/SmartLink";
import { ResolvedSponsorshipCard } from "resolvers/data/sponsorshipCardResolver";
import styles from "./Sponsorship.module.scss";

const cx = classNames.bind(styles);

export interface SponsorshipCardProps {
    sponsor: ResolvedSponsorshipCard;
}

const Sponsorship: React.FC<ResolvedSponsorshipCard & { prefetch?: boolean }> = ({
    image,
    link,
    title,
    text,
    prefetch = false,
}) => {
    return (
        <div className={cx("card")}>
            <div className={cx("imageWrapper")}>
                <SmartLink href={link.href!} prefetch={!!prefetch}>
                    <a rel="noopener noreferrer" className={cx("imageLink")}>
                        <Image
                            src={image.src}
                            alt={image.alt}
                            layout="fill"
                            objectFit="scale-down"
                            className={cx("image")}
                        />
                    </a>
                </SmartLink>
            </div>
            <div className={cx("contentWrapper")}>
                <h2 className={cx("title")}>{title}</h2>
                <div>
                    <p className={cx("text")}>{text}</p>
                </div>
                <p>
                    For more information visit:{" "}
                    <SmartLink href={link.href!} prefetch={!!prefetch}>
                        <a rel="noopener noreferrer" className={cx("link")}>
                            {link.title}
                        </a>
                    </SmartLink>
                </p>
            </div>
        </div>
    );
};

export default Sponsorship;
